import { useLayoutEffect, useState } from 'react'

import { getAsyncWidgetMeta, getWidgetMeta } from 'core-components/sitebuilder/helpers/MetaSelector'
import { IMetaInformation } from 'core-components/sitebuilder/models/IMetaInformation'

interface IUseWidgetMetaData {
  widgetId: string
}

export const useWidgetMetaData = ({ widgetId }: IUseWidgetMetaData) => {
  const [meta, setMeta] = useState<IMetaInformation>(getWidgetMeta(widgetId))
  const [isMetaLoading, setIsMetaLoading] = useState<boolean>(false)

  useLayoutEffect(() => {
    const isEmptyMeta = !Object.keys(meta).length
    if (isEmptyMeta) {
      setIsMetaLoading(true)
      getAsyncWidgetMeta(widgetId)
        .then((newMeta) => {
          setMeta((prev) => {
            return JSON.stringify(prev) === JSON.stringify(newMeta) ? prev : newMeta
          })
        })
        .finally(() => setIsMetaLoading(false))
    }
  }, [widgetId])

  return { isMetaLoading, meta }
}
